module.exports = __webpack_public_path__ + "static/media/7.43e728b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gifts/flowers/7.png
// module id = 133
// module chunks = 0